TPS.HomeShipment = {
    usAddressStreetInput: null,
    usAddressCityInput: null,
    usAddressZipInput: null,
    preferredDealerRadioPlaceholderText: null,
    preferredDealerRadioPlaceholder: null,
    preferredDealerRadioInputsWrapper: null,
    preferredDealerRadios: null,
    preferredDealerAutocomplete: null,
    preferredDealerAutocompleteSelected: null,
    preferredDealerName: null,
    preferredDealerCode: null,

    init: function () {
        this.usAddressStreetInput = document.querySelector('.tps-homeshipment-usaddress-street');
        this.usAddressCityInput = document.querySelector('.tps-homeshipment-usaddress-city');
        this.usAddressZipInput = document.querySelector('.tps-homeshipment-usaddress-zip input');
        this.preferredDealerRadioPlaceholderText = 'Please enter your US address to see the nearest dealers.';
        this.preferredDealerRadioPlaceholder = document.querySelector('.tps-homeshipment-preferred-retailer-radio-placeholder');
        this.preferredDealerRadioInputsWrapper = document.querySelector('.tps-homeshipment-preferred-retailer-radio-input-wrapper');
        this.preferredDealerRadios = document.querySelectorAll('.tps-homeshipment-preferred-retailer-radio input[type="radio"]');
        this.preferredDealerAutocomplete = document.querySelector('.tps-homeshipment-preferred-retailer-autocomplete input');
        this.preferredDealerAutocompleteSelected = document.querySelector('.tps-homeshipment-preferred-retailer-autocomplete-selected');
        this.preferredDealerName = document.querySelector('.tps-homeshipment-preferred-retailer-name');
        this.preferredDealerCode = document.querySelector('.tps-homeshipment-preferred-retailer-code');

        TPS.Util.loadWebserviceJS('CMSApp.AV.API.NearestDealer');

        if (this.usAddressStreetInput
            && this.usAddressCityInput
            && this.usAddressZipInput
            && this.preferredDealerRadios
            && this.preferredDealerAutocomplete
            && this.preferredDealerName
            && this.preferredDealerCode
            && this.preferredDealerRadioPlaceholder
            && this.preferredDealerRadioInputsWrapper) {
            this.setEvent_usAddressChange();
            this.setEvent_preferredDealerRadiosChange();
            this.setEvent_preferredDealerAutocompleteChange();
            this.maybePopulatePreferredDealerRadios(false);
        }
    },

    setEvent_usAddressChange: function () {
        var self = this;

        jQuery([self.usAddressStreetInput, self.usAddressCityInput, self.usAddressZipInput]).on('keyup', function (e) {
            self.maybePopulatePreferredDealerRadios();
        });
    },

    setEvent_preferredDealerRadiosChange: function () {
        var self = this;

        jQuery(self.preferredDealerRadios).on('change', function (e) {
            self.preferredDealerName.value = this.dataset.name;
            self.preferredDealerCode.value = this.value;
            self.preferredDealerAutocomplete.value = '';
            self.preferredDealerAutocompleteSelected.classList.add('hide');

            // save values to keep them after postback
            window.homeShipmentValues.value = this.value;
            window.homeShipmentValues.label = this.dataset.name;
            window.homeShipmentValues.type = 'radio';
            window.homeShipmentValues.autocompleteSelectedAddress = null;
        });
    },

    setEvent_preferredDealerAutocompleteChange: function () {
        var self = this;

        // workaround to wait till self.preferredDealerAutocomplete.AutoCompleteBehavior._events exists (it doesn't on load)
        jQuery(self.preferredDealerAutocomplete).on('keydown', function (e) {
            if (self.preferredDealerAutocomplete.AutoCompleteBehavior && self.preferredDealerAutocomplete.AutoCompleteBehavior._events && self.preferredDealerAutocomplete.AutoCompleteBehavior._events._list && !self.preferredDealerAutocomplete.AutoCompleteBehavior._events._list.itemSelected) {
                self.preferredDealerAutocomplete.AutoCompleteBehavior._events._list.itemSelected = [function (source, eventArgs) {
                    if (source) {
                        self.preferredDealerRadios.forEach(function (radio) {
                            radio.checked = false;
                        });

                        const value = eventArgs.get_value().split(';')[0];
                        const address = eventArgs.get_value().split(';')[1];

                        self.preferredDealerName.value = eventArgs.get_text();
                        self.preferredDealerCode.value = value;
                        self.preferredDealerAutocompleteSelected.querySelector('div').innerHTML = address;
                        self.preferredDealerAutocompleteSelected.classList.remove('hide');

                        // save values to keep them after postback
                        window.homeShipmentValues.value = value;
                        window.homeShipmentValues.label = eventArgs.get_text();
                        window.homeShipmentValues.type = 'autocomplete';
                        window.homeShipmentValues.autocompleteSelectedAddress = address;
                    }
                    return false;
                }];

            }
        });
    },

    maybePopulatePreferredDealerRadios: function (clearInputs = true) {
        var self = this;

        if (clearInputs === true) {
            self.setPlaceholderState(true, self.preferredDealerRadioPlaceholderText);

            self.preferredDealerRadios.forEach(function (radio) {
                radio.checked = false;
            });
            self.preferredDealerAutocomplete.value = '';
            self.preferredDealerCode.value = '';
            self.preferredDealerName.value = '';
            self.preferredDealerAutocompleteSelected.classList.add('hide');
        } else {
            // populate if there are saved values
            if (window.homeShipmentValues.type === 'autocomplete') {
                self.preferredDealerAutocomplete.value = window.homeShipmentValues.label;
                self.preferredDealerAutocompleteSelected.classList.remove('hide');
                self.preferredDealerAutocompleteSelected.querySelector('div').innerHTML = window.homeShipmentValues.autocompleteSelectedAddress;
            }
        }

        var address = self.usAddressCityInput.value;
        var city = self.usAddressStreetInput.value;
        var zip = self.usAddressZipInput.value;
        var countryID = 271; // US

        if (address.length > 0 && city.length > 0 && zip.length > 4) {
            self.setPlaceholderState(true, 'spinner');

            CMSApp.AV.API.NearestDealer.GetNearestDealersByPinAddress(address, city, zip, countryID, 'APLAN', function (d) {
                if (d.length > 0) {
                    d.sort(function (a, b) {
                        return a.Distance - b.Distance;
                    });

                    self.preferredDealerRadios.forEach(function (elem, index) {
                        elem.value = d[index].Code;
                        elem.dataset.name = d[index].Name;
                        var labelHTML = self.getDealerRadioLabelHtml(d[index].Name, d[index].Address, d[index].City, d[index].State, d[index].Zipcode, d[index].Distance, d[index].DistanceUnit);
                        jQuery(elem).next('label').html(labelHTML);

                        // populate if there are saved values
                        if (clearInputs === false && window.homeShipmentValues.type === 'radio') {
                            if (elem.value === window.homeShipmentValues.value) {
                                elem.checked = true;
                            }
                        }
                    });

                    self.setPlaceholderState(false);
                } else {
                    self.setPlaceholderState(true, self.preferredDealerRadioPlaceholderText);
                }
            }, function (d) {
                    self.setPlaceholderState(true, self.preferredDealerRadioPlaceholderText);
            });
        }
    },

    getDealerRadioLabelHtml: function (name, street, city, state, zip, distance, distanceUnit) {
        return `
            <div class="tps-homeshipment-preferred-retailer-radio-dealer">
                <div class="tps-homeshipment-preferred-retailer-radio-dealer-content">
                    <strong>${name}</strong>
                    <div>${street}, ${city}${state ? ', ' + state : ''}, ${zip}</div>
                </div>
                <div class="tps-homeshipment-preferred-retailer-radio-dealer-distance">
                    ${Math.round(distance/1609)} ${distanceUnit}
                </div>
            </div>`;
    },

    setPlaceholderState: function (visible, text = '') {
        var self = this;

        if (visible == true) {
            var html = text === 'spinner' ? '<div class="spinner"></div>' : text;

            self.preferredDealerRadioPlaceholder.innerHTML = html;

            self.preferredDealerRadioInputsWrapper.classList.add('hide');
            self.preferredDealerRadioPlaceholder.classList.remove('hide');
        } else {
            self.preferredDealerRadioInputsWrapper.classList.remove('hide');
            self.preferredDealerRadioPlaceholder.classList.add('hide');
        }
    }
}
